import { BrandMark } from '@/components/BrandMark';

/**
 * How a screen says it is waiting (owner, 2026-11-03, canvas "AttireRent Loader & Splash"): a list
 * shows its own rows as a shimmer (Grid A, in `DataView`), everything else the logo pulsing over a
 * running line (Screen C, here). The look is `style.css`, under "Loaders".
 */

/** The thin bar along the top of a card while its list reads. Static outside a card. */
export function LoadBar() {
  return (
    <div className="load-bar" aria-hidden="true">
      <div className="load-bar-run" />
    </div>
  );
}

function PulsingLogo({ size }: { size: number }) {
  return (
    <span className="pulse-logo" style={{ width: size, height: size }}>
      <span className="pulse-ring" style={{ borderRadius: size * 0.3 }} />
      <span className="pulse-ring pulse-ring-late" style={{ borderRadius: size * 0.3 }} />
      <BrandMark size={size} radius={size * 0.28} className="pulse-tile" />
    </span>
  );
}

/** A panel or page with no rows to imitate. `compact` for a narrow rail or a drawer. */
export function PageLoader({ label, compact = false }: { label: string; compact?: boolean }) {
  return (
    <div
      role="status"
      className={`flex flex-col items-center justify-center text-center ${
        compact ? 'gap-4 py-8' : 'min-h-80 gap-6 py-10'
      }`}
    >
      <PulsingLogo size={compact ? 44 : 72} />
      <div className="flex flex-col items-center gap-2.5">
        <p className="text-title m-0 text-[length:var(--scale-font-size)] font-semibold">{label}</p>
        <div className="load-line" aria-hidden="true">
          <div className="load-line-run" />
        </div>
      </div>
    </div>
  );
}

/** The whole window while a reload signs back in. */
export function WindowLoader() {
  return (
    <div role="status" aria-label="Signing you back in" className="window-loader">
      <PulsingLogo size={96} />
      <div className="flex flex-col items-center gap-3">
        <p className="window-loader-name">AttireRent</p>
        <div className="load-line" aria-hidden="true">
          <div className="load-line-run" />
        </div>
      </div>
    </div>
  );
}
